import react from "@tippyjs/react";
import { inlinePositioning, animateFill, followCursor } from "tippy.js";
import * as tippy_1 from "tippy.js/dist/tippy.css";
import * as backdrop from "tippy.js/dist/backdrop.css";
import * as scale from "tippy.js/animations/scale.css";
import * as scale$002Dsubtle from "tippy.js/animations/scale-subtle.css";
import * as scale$002Dextreme from "tippy.js/animations/scale-extreme.css";
import * as perspective from "tippy.js/animations/perspective.css";
import * as perspective$002Dsubtle from "tippy.js/animations/perspective-subtle.css";
import * as perspective$002Dextreme from "tippy.js/animations/perspective-extreme.css";
import * as shift$002Daway from "tippy.js/animations/shift-away.css";
import * as shift$002Daway$002Dsubtle from "tippy.js/animations/shift-away-subtle.css";
import * as shift$002Daway$002Dextreme from "tippy.js/animations/shift-away-extreme.css";
import * as shift$002Dtoward from "tippy.js/animations/shift-toward.css";
import * as shift$002Dtoward$002Dsubtle from "tippy.js/animations/shift-toward-subtle.css";
import * as shift$002Dtoward$002Dextreme from "tippy.js/animations/shift-toward-extreme.css";
import * as light from "tippy.js/themes/light.css";
import * as light$002Dborder from "tippy.js/themes/light-border.css";
import * as material from "tippy.js/themes/material.css";
import * as translucent from "tippy.js/themes/translucent.css";
import { tryLast, partition } from "../fable-library.3.1.11/Array.js";
import { toArray } from "../fable-library.3.1.11/Seq.js";
import { map, toNullable } from "../fable-library.3.1.11/Option.js";
import { Record, Union } from "../fable-library.3.1.11/Types.js";
import { class_type, string_type, record_type, int32_type, union_type } from "../fable-library.3.1.11/Reflection.js";

export const tippy = react;

export const Plugins_followCursor = followCursor;

export const Plugins_animateFill = animateFill;

export const Plugins_inlinePositioning = inlinePositioning;



















export function splitChildProps(props) {
    const patternInput = partition((tupledArg) => (tupledArg[0] === "children"), toArray(props));
    return {
        Children: toNullable(map((tuple) => tuple[1], tryLast(patternInput[0]))),
        Props: patternInput[1],
    };
}

export class Placement extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Top", "TopStart", "TopEnd", "Right", "RightStart", "RightEnd", "Bottom", "BottomStart", "BottomEnd", "Left", "LeftStart", "LeftEnd", "Auto", "AutoStart", "AutoEnd"];
    }
}

export function Placement$reflection() {
    return union_type("Feliz.Tippy.Placement", [], Placement, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Placement__get_Value(this$) {
    switch (this$.tag) {
        case 1: {
            return "top-start";
        }
        case 2: {
            return "top-end";
        }
        case 3: {
            return "right";
        }
        case 4: {
            return "right-start";
        }
        case 5: {
            return "right-end";
        }
        case 6: {
            return "bottom";
        }
        case 7: {
            return "bottom-start";
        }
        case 8: {
            return "bottom-end";
        }
        case 9: {
            return "left";
        }
        case 10: {
            return "left-start";
        }
        case 11: {
            return "left-end";
        }
        case 12: {
            return "auto";
        }
        case 13: {
            return "auto-start";
        }
        case 14: {
            return "auto-end";
        }
        default: {
            return "top";
        }
    }
}

export class Milliseconds extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Milliseconds"];
    }
}

export function Milliseconds$reflection() {
    return union_type("Feliz.Tippy.Milliseconds", [], Milliseconds, () => [[["Item", int32_type]]]);
}

export function Milliseconds__get_Value(this$) {
    return this$.fields[0];
}

export class AnimationVariation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Normal", "Subtle", "Extreme"];
    }
}

export function AnimationVariation$reflection() {
    return union_type("Feliz.Tippy.AnimationVariation", [], AnimationVariation, () => [[], [], []]);
}

export function AnimationVariation__get_Value(this$) {
    switch (this$.tag) {
        case 1: {
            return "-subtle";
        }
        case 2: {
            return "-extreme";
        }
        default: {
            return "";
        }
    }
}

export class Animation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Fade", "Scale", "Perspective", "ShiftAway", "ShiftToward"];
    }
}

export function Animation$reflection() {
    return union_type("Feliz.Tippy.Animation", [], Animation, () => [[], [["Item", AnimationVariation$reflection()]], [["Item", AnimationVariation$reflection()]], [["Item", AnimationVariation$reflection()]], [["Item", AnimationVariation$reflection()]]]);
}

export function Animation__get_Value(this$) {
    switch (this$.tag) {
        case 1: {
            return "scale" + AnimationVariation__get_Value(this$.fields[0]);
        }
        case 2: {
            return "perspective" + AnimationVariation__get_Value(this$.fields[0]);
        }
        case 3: {
            return "shift-away" + AnimationVariation__get_Value(this$.fields[0]);
        }
        case 4: {
            return "shift-toward" + AnimationVariation__get_Value(this$.fields[0]);
        }
        default: {
            return "fade";
        }
    }
}

export class Rect extends Record {
    constructor(Width, Height, Left, Right, Top, Bottom) {
        super();
        this.Width = (Width | 0);
        this.Height = (Height | 0);
        this.Left = (Left | 0);
        this.Right = (Right | 0);
        this.Top = (Top | 0);
        this.Bottom = (Bottom | 0);
    }
}

export function Rect$reflection() {
    return record_type("Feliz.Tippy.Rect", [], Rect, () => [["Width", int32_type], ["Height", int32_type], ["Left", int32_type], ["Right", int32_type], ["Top", int32_type], ["Bottom", int32_type]]);
}

export class HideOnClick extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Hide", "DontHide", "Toggle"];
    }
}

export function HideOnClick$reflection() {
    return union_type("Feliz.Tippy.HideOnClick", [], HideOnClick, () => [[], [], []]);
}

export class Trigger extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["MouseEnter", "Focus", "Click", "FocusIn", "Manual"];
    }
}

export function Trigger$reflection() {
    return union_type("Feliz.Tippy.Trigger", [], Trigger, () => [[], [], [], [], []]);
}

export function Trigger__get_Value(this$) {
    switch (this$.tag) {
        case 1: {
            return "focus";
        }
        case 2: {
            return "click";
        }
        case 3: {
            return "focusin";
        }
        case 4: {
            return "manual";
        }
        default: {
            return "mouseenter";
        }
    }
}

export class Offset extends Record {
    constructor(Skidding, Distance) {
        super();
        this.Skidding = (Skidding | 0);
        this.Distance = (Distance | 0);
    }
}

export function Offset$reflection() {
    return record_type("Feliz.Tippy.Offset", [], Offset, () => [["Skidding", int32_type], ["Distance", int32_type]]);
}

export class Theme extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Light", "LightBorder", "Material", "Translucent", "Custom"];
    }
}

export function Theme$reflection() {
    return union_type("Feliz.Tippy.Theme", [], Theme, () => [[], [], [], [], [["Item", string_type]]]);
}

export function Theme__get_Value(this$) {
    switch (this$.tag) {
        case 1: {
            return "light-border";
        }
        case 2: {
            return "material";
        }
        case 3: {
            return "translucent";
        }
        case 4: {
            return this$.fields[0];
        }
        default: {
            return "light";
        }
    }
}

export class TouchBehaviour extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["On", "Off", "Hold", "LongPress"];
    }
}

export function TouchBehaviour$reflection() {
    return union_type("Feliz.Tippy.TouchBehaviour", [], TouchBehaviour, () => [[], [], [], [["Item", class_type("System.TimeSpan")]]]);
}

